<template>
  <div id="app" class="h-100">
    <router-view />
  </div>
</template>

<script>
export default {
  metaInfo() {
    const location = window.location;
    return {
      title: "Invown - Marketplace",
      meta: [
        {
          name: "description",
          content:
            "Invown is a two-sided marketplace where companies offer investment opportunities to everyday investors.",
        },
        {
          property: "og:description",
          content: "A New Alternative To Real Estate Investing",
        },
        { property: "og:title", content: "Invown - Marketplace" },
        { property: "og:site_name", content: "Invown" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
      link: [
        {
          rel: "canonical",
          href: location.protocol + "//" + location.host + "/app" + this.$route.fullPath,
        },
      ],
    };
  },
};
</script>

<style>
html,
body {
  height: 100%;
  @font-face {
    font-family: Inter;
    font-display: swap;
  }
}

.modal-fullscreen .modal-dialog {
  max-width: min(1000px, calc(100% - 3.5rem));
  height: 100%;
}

/* Ensure tooltips render above modals (modal-body is z-index:99999 in custom.scss) */
.tooltip {
  z-index: 10000000 !important;
}

/* Center text+icon in ALL buttons globally */
.btn,
button.btn,
a.btn,
.btn-primary,
.btn-secondary,
.btn-success,
.btn-danger,
.btn-warning,
.btn-info,
.btn-outline-primary,
.btn-outline-secondary,
.btn-toggle,
.btn-touch,
.btn-touch-sm,
[class*="btn-"] {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  gap: 4px;
}
/* Ensure btn-block stays full-width when inline-flex */
.btn.btn-block,
.btn.w-100 {
  display: flex !important;
  width: 100% !important;
}
.tooltip .tooltip-inner {
  max-width: 300px;
  text-align: left;
  font-size: 13px;
  padding: 6px 10px;
}

.my-carousel .carousel-indicators li {
  background-color: red;
}
.my-carousel,
.my-carousel .carousel-inner,
.my-carousel img {
  height: 320px;
  width: 450px;
}
.my-carousel img {
  object-fit: cover;
  border-radius: 1.6rem;
  border-bottom-right-radius: 0;
}
.my-carousel .carousel-caption {
  color: red;
  text-align: left;
  bottom: 0;
  left: 8%;
  padding-bottom: 5px;
}

/* ── Unified Tooltip Icon Style (TT-4) ── */
.invown-tip-icon {
  color: #6c757d;
  font-size: 0.875rem;
  vertical-align: middle;
  transition: color 0.15s;
  cursor: help;
}
.invown-tip-icon:hover {
  color: #495057;
}
.invown-tooltip__trigger {
  cursor: help;
  outline: none;
  display: inline-flex;
  align-items: center;
}

/* ── Global Button Text Centering (all .btn variants) ── */
.btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px;
}
</style>

<!-- 
max-width: 100%;
margin: 0;
top: 0;
bottom: 0;
left: 0;
right: 0;
display: flex;
position: fixed;
z-index: 100000;
-->